import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { RetraitClientNetRequest } from 'src/app/models/retraitClientNetRequest';
import { PayService } from 'src/app/service/pay.service';
import { UserSessionService } from 'src/app/user-session.service';

@Component({
  selector: 'app-retrait',
  templateUrl: './retrait.component.html',
  styleUrls: ['./retrait.component.css'],
  standalone: false
})
export class RetraitComponent implements OnInit {
  retrait: UntypedFormGroup;
  succesmessageR: boolean;
  errorR1: boolean;
  errorR3: boolean;
  errorR4: boolean;
  username: string;
  errorR5: boolean;
  totalDepots: any;
  totalbeneficedepot: any;
  totalRetrait: any;
  totalbeneficeretrait: any;
  depotMensualite: any[];
  errorR2: boolean;
  soldeMensuel: any;
  errorR6: boolean;
  errorR11: boolean;
  errorR12: boolean;
  errorR13: boolean;
  errorR14: boolean;
  sigle: string;
  matriculeEmploye: string = '';
  isSubmittingRetrait: boolean = false;

  constructor(private userService: PayService, private userSessionService: UserSessionService) { }

  ngOnInit(): void {
    this.username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    this.sigle = this.userSessionService.getSigle() || 'FCFA';
    this.ngRetrait();
    this.getBaccountInformation();
    this.loadEmployeeOperationSecurity();
  }

  ngRetrait() {
    this.retrait = new UntypedFormGroup(
      {
        montantRetrait: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
        codeRetrait: new UntypedFormControl('', [Validators.required, Validators.pattern('([0-9]{4}|[0-9]{9})$')]),
        supervisorCode: new UntypedFormControl('', [Validators.required]),
        d10000: new UntypedFormControl(0),
        d5000: new UntypedFormControl(0),
        d2000: new UntypedFormControl(0),
        d1000: new UntypedFormControl(0),
        d500: new UntypedFormControl(0)

      })
  }

  getBaccountInformation() {
    this.userService.getPartenairebAccount(this.username).subscribe(data => {
      console.log(data);
      this.soldeMensuel = data['accountBalance']
      this.totalDepots = data['sdepotPartenaire'];
      this.totalbeneficedepot = data['bdepot'];
      this.totalRetrait = data['sretraitPartenaire'];
      this.totalbeneficeretrait = data['bretrait']
      this.getMensualitePartenaire();
    })
  }

  getMensualitePartenaire() {
    this.userService.getPartenaireMensualite(this.username).subscribe((data: any[]) => {
      console.log(data);
      this.depotMensualite = data;

    })
  }

  loadEmployeeOperationSecurity() {
    this.userService.getEmployeeOperationSecurity(this.username).subscribe((data: any) => {
      this.matriculeEmploye = data?.matriculeEmploye ?? '';
      this.retrait.patchValue({ supervisorCode: data?.operationValidationCode ?? '' });
    });
  }

  makeRetrait(formdata: any) {
    if (this.isSubmittingRetrait || !this.retrait?.valid) {
      return;
    }
    this.isSubmittingRetrait = true;

    const codeStr = String(formdata.codeRetrait ?? '').trim();
    const isBusiness = /^[0-9]{9}$/.test(codeStr);

    const supervisorCode = formdata.supervisorCode?.trim() || undefined;
    const req: RetraitClientNetRequest = {
      codeRetrait: Number(codeStr),
      montantRetrait: Number(formdata.montantRetrait),
      partenaireUsername: this.username, // partenaire ou caissier connecté
      partenaireUniqueNumeroIdentification: supervisorCode,
      supervisorCode,
      billetBreakdown: this.buildBilletBreakdown(formdata)
    };
    console.log('RetraitClientNetRequest:', req);
    const call$ = isBusiness
      ? this.userService.retraitClientNetSurCompteBusiness(req)
      : this.userService.retraitClientNetSurComptePrimaire(req);

    call$
      .pipe(finalize(() => { this.isSubmittingRetrait = false; }))
      .subscribe({
        next: (data: number) => {
          this.resetRetraitErrors();

          if (data === 0) {
            this.succesmessageR = true;
            this.getBaccountInformation();
            this.loadEmployeeOperationSecurity();
            setTimeout(() => this.succesmessageR = false, 4000);
            return;
          }

          // mapping erreurs existantes
          if (data === -1) this.flash('errorR1');
          else if (data === -2) this.flash('errorR2'); // "ne doit pas arriver"
          else if (data === -3) this.flash('errorR3');
          else if (data === -4) this.flash('errorR4');
          else if (data === -5) this.flash('errorR5');
          else if (data === -6) this.flash('errorR6');
          else if (data === -11) this.flash('errorR11');
          else if (data === -12) this.flash('errorR12');
          else if (data === -13) this.flash('errorR13');
          else if (data === -14) this.flash('errorR14');
        },
        error: () => {
          this.flash('errorR2');
        }
      });
  }

  /** utilitaires */
  private resetRetraitErrors() {
    this.errorR1 = this.errorR2 = this.errorR3 = this.errorR4 = this.errorR5 = this.errorR6 = this.errorR11 = this.errorR12 = this.errorR13 = this.errorR14 = false;
  }

  private flash(flag: 'errorR1' | 'errorR2' | 'errorR3' | 'errorR4' | 'errorR5' | 'errorR6' | 'errorR11' | 'errorR12' | 'errorR13' | 'errorR14') {
    (this as any)[flag] = true;
    setTimeout(() => (this as any)[flag] = false, 4000);
  }

  private buildBilletBreakdown(formdata: any): Record<string, number> {
    const breakdown: Record<string, number> = {};
    const entries: Array<[string, any]> = [
      ['10000', formdata.d10000],
      ['5000', formdata.d5000],
      ['2000', formdata.d2000],
      ['1000', formdata.d1000],
      ['500', formdata.d500]
    ];
    for (const [denomination, rawCount] of entries) {
      const count = Number(rawCount ?? 0);
      if (Number.isFinite(count) && count > 0) {
        breakdown[denomination] = Math.trunc(count);
      }
    }
    return breakdown;
  }







  get montantRetrait() { return this.retrait.get('montantRetrait'); }
  get codeRetrait() { return this.retrait.get('codeRetrait'); }

}
